import type { PageKeys } from 'consts/api';
import { FLOW_TYPE } from 'consts/flows';
import get from 'lodash/get';
import type { Language, Translations } from 'store/state';

export function translate(
	key: string,
	page: PageKeys,
	exact: boolean,
	language: Language,
	translations: Translations
) {
	if (key.includes(FLOW_TYPE.RR_SU)) {
		const txt = get(translations, `${language}.${page}.${key}`);
		return typeof txt === 'string' ? txt : key;
	}
	const i = exact ? key : key.replace(/rr-/i, '').replace(/av/i, 'mv');
	return get(translations, `${language}.${page}.${i}`) || '';
}
